
export default {
  list: [],
  availableAppointments: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/proced/state.js